import script from "./spotCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./spotCheck.vue?vue&type=script&setup=true&lang=ts"

import "./spotCheck.vue?vue&type=style&index=0&id=17355da6&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17355da6"]])

export default __exports__